module.exports = __webpack_public_path__ + "static/media/numberking.5954e2ed.webp";